import type { ListBuilderList } from '../../../types';
import { createCartSuggestionColumns } from '../columns';

/**
 * The "Frequently bought together" strip beneath the cart, rendered as the
 * same table as the cart lines above it with the same columns (PD-13666) —
 * minus the line total, which an item that is not in the cart does not have,
 * and the remove action, which would have nothing to act on.
 *
 * No mobile card config: on a phone the strip is a short capped list under the
 * cart, and the zoned-card treatment would give four suggestions the same
 * visual weight as the lines being ordered.
 */
export const cartSuggestionsDefaultList: ListBuilderList = {
	id: 'cart_suggestions_default',
	name: 'Frequently bought together',
	type: 'default',
	active: true,
	sortOrder: 0,
	columns: createCartSuggestionColumns(),
	description: 'Items frequently bought with what is already in the cart',
	// The cart's own field set, minus the ones a not-yet-ordered line has no
	// value for (line total, subtotal, minimum price, the short-date and
	// active flags the cart endpoint flattens onto an order line).
	requiredFields: [
		'_id',
		'_fk_item__id',
		'itemId',
		'itemDescription',
		'itemManufacturer',
		'itemNumber',
		'itemNDC',
		'totalStock',
		'soonestExpirationDate',
		'perOrderLimit',
		'quantityOrdered',
		'price',
		'primaryImageUrl',
	],
};
